module.exports = __webpack_public_path__ + "img/sportbil.303f0ae8.jpg";